<template lang="pug">
  v-text-field(
    v-bind="{ ...$attrs, value }"
    @input="x => $emit('input', x)"

    :type="showPassword ? 'text' : 'password'"
    :append-icon="showPassword ? 'visibility' : 'visibility_off'"
    @click:append="showPassword = !showPassword"
  )
</template>

<script>
  export default {
    name: 'password-text-field',
    props: ['value'],
    data() {
      return {
        password: '',
        showPassword: false,
      }
    },
  }
</script>
